"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogMatcherForAmounts = exports.createLogMatcherForActions = void 0;
var log_finder_1 = require("@terraclassic-community/log-finder");
var createLogMatcherForActions = function (injectedLogFindersRuleSet) {
    if (injectedLogFindersRuleSet === void 0) { injectedLogFindersRuleSet = []; }
    var logFindersRuleSet = __spreadArray([], injectedLogFindersRuleSet, true);
    var logFinders = logFindersRuleSet.map(function (_a) {
        var rule = _a.rule, transform = _a.transform;
        return (0, log_finder_1.createReturningLogFinder)(rule, transform);
    });
    return function (events) {
        return events === null || events === void 0 ? void 0 : events.flatMap(function (event) {
            return logFinders === null || logFinders === void 0 ? void 0 : logFinders.map(function (logFinderFn) { return logFinderFn(event); });
        });
    };
};
exports.createLogMatcherForActions = createLogMatcherForActions;
var createLogMatcherForAmounts = function (injectedLogFindersRuleSet) {
    if (injectedLogFindersRuleSet === void 0) { injectedLogFindersRuleSet = []; }
    var logFindersRuleSet = __spreadArray([], injectedLogFindersRuleSet, true);
    var logFinders = logFindersRuleSet.map(function (_a) {
        var rule = _a.rule, transform = _a.transform;
        return (0, log_finder_1.createReturningLogFinder)(rule, transform);
    });
    return function (events) {
        return events === null || events === void 0 ? void 0 : events.flatMap(function (event) {
            return logFinders === null || logFinders === void 0 ? void 0 : logFinders.map(function (logFinderFn) { return logFinderFn(event); });
        });
    };
};
exports.createLogMatcherForAmounts = createLogMatcherForAmounts;
//# sourceMappingURL=execute.js.map